export const initialActiveCategory = {
  value: null,
  label: null,
};
